import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, LoadMore, Button, MediaBox } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import InquiryService from 'services/inquiry';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import { Link } from 'react-router-dom';
import Big from 'big.js';
import CommonFns from 'functions/common.ts';
import PriceCompare from 'components/priceCompare';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Http from 'services/http2';
import ModalService from 'services/modal';
import Download from 'components/download.js';
//单头自定义字段
import HeadCustField from 'components/headCustField';

// https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Finquiry%2Fquote-compare%2Fdetail%2F91904378%2F5917449617895515&response_type=code&scope=snsapi_base&state=123#wechat_redirect

function PriceCompareDetail(props) {
  const Config = {
    purchase: {
      title: '供应商询价招标详情',
      apiPath: '/b2bPriceCompareOrder/detail',
      publishApiPath: '/b2bPriceCompareOrder/sendResult',
      finishApiPath: '/b2bPriceCompareOrder/finish',
      reactivateApiPath: '/b2bPriceCompareOrder/reactivate',
      terminateApiPath: '/b2bPriceCompareOrder/terminate',
      enumMainKey: 'B02_Inquiry_Status',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      custFieldBillType: 51, //自定义字段单别
      arrEnumField: [
        {
          mainKey: 'B02_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Inquiry_Bill_Type',
          subKey: 'billType',
          value: 'billTypeName'
        }
      ],
      idField: 'pcXkNo',
      quoteName: '报价',
      detailParams: { pageSize: 100 }
    }
  };

  const { state, dispatch } = useContext(ActionContext);
  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [isWfLineEdit, setIsWfLineEdit] = useState(false);
  const [companyParamObj, setCompanyParamObj] = useState({});
  const config = Config[props.type];
  config.dispatch = dispatch;

  const {
    companyCode,
    inited,
    error,
    redirect,
    decimalPlace,
    detail,
    setDetail,
    forceUpdate,
    fileList,
    setShowLoading,
    setFileList,
    workflow,
    setWorkflow,
    fieldSetting,
    self
  } = useDetail(props, config);
  self.idField = 'pcXkNo';
  self.countTimer = 0;
  self.countDownTimer = 0;

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (data.pageLineList && Array.isArray(data.pageLineList.list)) {
      data.pageLineList.list.forEach(item => {
        item.activeFlag = true;
        Util.genExtendFields(item);
        if (Array.isArray(item.detailList)) {
          item.detailList.forEach(line => {
            //判断是否含税,价格是否含税 0:不限；1:含税价；2:未税价; 默认值:0"，不限时，税率为0则未税
            if (line.priceContainTaxFlag === 0) {
              if (line.taxRate > 0) {
                line.priceContainTaxFlagShow = '含税';
              } else {
                line.priceContainTaxFlagShow = '不含税';
              }
            } else if (line.priceContainTaxFlag === 1) {
              line.priceContainTaxFlagShow = '含税';
            } else if (line.priceContainTaxFlag === 2) {
              line.priceContainTaxFlagShow = '不含税';
            } else {
              line.priceContainTaxFlagShow = '不含税';
            }
            line.taxRateShow = !Util.isEmpty(line.taxRate)
              ? parseFloat(Big(line.taxRate).times(100).valueOf())
              : undefined; //按百分比显示税率
            //计算报价金额
            line.quoteAmountTotal = line.subList?.length ? 0 : undefined;
            if (Array.isArray(line.subList)) {
              line.subList.forEach(quote => {
                if (
                  Util.isBig(quote.quoteAmount) &&
                  Util.isBig(line.quoteAmountTotal)
                ) {
                  line.quoteAmountTotal = Number(
                    Big(line.quoteAmountTotal).plus(quote.quoteAmount).valueOf()
                  );
                }
                if (
                  Util.isBig(quote.quoteBaseAmount) &&
                  Util.isBig(line.quoteBaseAmountTotal)
                ) {
                  line.quoteBaseAmountTotal = Number(
                    Big(line.quoteBaseAmountTotal)
                      .plus(quote.quoteBaseAmount)
                      .valueOf()
                  );
                }
              });
              line.quoteAmountString = line.subList
                .map(quote => quote.quoteAmount)
                .join(',');
              line.quoteBaseAmountString = line.subList
                .map(quote => quote.quoteBaseAmount)
                .join(',');
            }
          });
        }
      });
    }
    if (data.billType === 1) {
      setWorkflow({ wfmCode: '1045' });
    } else {
      setWorkflow({ wfmCode: '1046' });
    }

    //处理 textarea
    data.biddingSummaryShow = CommonFns.formatText(data.biddingSummary);

    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      pcXkNo: detail.pcXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  function handleOrder(type) {
    switch (type) {
      case 'publish':
        act(config.publishApiPath, 'publishPriceCompare');
        break;
      case 'terminate':
        act(config.terminateApiPath, 'terminatePriceCompare');
        break;
      case 'reactivate':
        act(config.reactivateApiPath, 'reactivatePriceCompare');
        break;
      case 'finish':
        act(config.finishApiPath, 'finishPriceCompare');
        break;
      default:
    }
  }

  function handle(type) {
    // switch (type) {
    //   case 'publish':
    //     this.dialogMsg = '确认发布比价结果？';
    //     break;
    //   case 'terminate':
    //     this.dialogMsg =
    //       '终止后，询价/招标结果不会发送给供应商，您确定要进行该操作吗？';
    //     break;
    //   case 'reactivate':
    //     this.dialogMsg = '您确认要重新比价吗？';
    //     break;
    //   case 'finish':
    //     this.dialogMsg = '您确认要结束比价吗？';
    //     break;
    //   default:
    // }
    handleOrder(type);
  }

  function act(api, type) {
    let postbody = getPostbody(api);
    InquiryService[type](
      postbody,
      () => {
        if (type === 'terminatePriceCompare') {
          dispatch({ type: 'hideReject' });
        }
        self.getDetail();
      },
      dispatch
    );
  }

  function handleDrawer(item) {
    item.activeFlag = !item.activeFlag;
    forceUpdate();
  }

  function handleInput(e, item, key) {
    item[key] = e.target.value;
    forceUpdate();
  }

  //查看附件
  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = obj.quoProdUniqueKey,
      xkNo = obj.pcXkNo,
      lineNo = obj.lineNo || '0',
      cCode = obj.companyCode;

    if (businessType === 118) {
      xkNo = obj.quoXkNo;
      lineNo = obj.inqLineNo;
      cCode = obj.vendorCode || obj.compVendor.vendorCode;
    }

    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });

    actions.openDownloadModal();
  }

  // 保存审批编辑字段
  function saveWfLine() {
    let lineList = [];
    detail.pageLineList?.list.forEach(prod => {
      let { lineNo, nextExpectedPrice, remark } = prod;
      if (!(Util.isEmpty(remark) && Util.isEmpty(nextExpectedPrice))) {
        lineList.push({ lineNo: lineNo, nextExpectedPrice, remark });
      }
    });
    let postbody = {
      apiPath: '/b2bPriceCompareOrder/nextExpectedPrice',
      companyCode: companyCode,
      pcXkNo: detail.pcXkNo,
      lineList
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        setIsWfLineEdit(false);
      } else {
        ModalService.showTip(response.errorMsg, dispatch);
      }
    });
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {currNavIndex === 0 && (
        <div className="pb50">
          <div className="order-detail-block">
            <div className="order-detail-title">
              <label>基础信息</label>
            </div>
            <ul>
              <li>
                <label className="order-detail-label">比价单号</label>
                <div className="order-detail-value">{detail.pcErpNo}</div>
              </li>
              <li>
                <label className="order-detail-label">比价标题</label>
                <div className="order-detail-value">{detail.billTitle}</div>
              </li>
              <li>
                <label className="order-detail-label">询价/招标类型</label>
                <div className="order-detail-value">{detail.billTypeName}</div>
              </li>
              <li>
                <label className="order-detail-label">发布人</label>
                <div className="order-detail-value">{detail.createName}</div>
              </li>
              <li>
                <label className="order-detail-label">发布时间</label>
                <div className="order-detail-value">
                  {formatDate(detail.createTime, 'YYYY-MM-DD HH:mm:ss')}
                </div>
              </li>
              <li>
                <label className="order-detail-label">状态</label>
                <div className="order-detail-value">
                  <span
                    className={
                      'u-sign ' +
                      CommonFns.getStatusClass('inquiry', detail.status)
                    }
                  >
                    {detail.statusName}
                  </span>
                </div>
              </li>
              {/* 审批流状态 仅开启后才显示 */}
              {workflow.isActive && (
                <li>
                  <label className="order-detail-label">审批环节</label>
                  <div className="order-detail-value">
                    <WorkflowStatus
                      companyCode={companyCode}
                      id={self.id}
                      workflow={workflow}
                      detail={detail}
                    />
                  </div>
                </li>
              )}
              {/* 审批流按钮 */}
              {self.isPurchase && workflow.isActive && (
                <li>
                  <label className="order-detail-label">审批操作</label>
                  <div className="order-detail-value">
                    <WorkflowButtons
                      companyCode={companyCode}
                      id={detail.inqXkNo}
                      workflow={workflow}
                      detail={detail}
                      onChange={() => {
                        self.getDetail();
                      }}
                    />
                  </div>
                </li>
              )}
            </ul>
          </div>

          {!Util.isEmpty(detail.inqList) && (
            <div className="order-detail-block">
              <div className="order-detail-title">
                <label>比价项目</label>
              </div>
              <div className="order-detail-list">
                <ul>
                  {detail.inqList.map((item, index) => (
                    <li className="order-detail-item" key={index}>
                      <ul className="clearfix">
                        <li>
                          {detail.billTypeName || '询价'}标题：
                          {item.inqBillTitle}
                        </li>
                        <li>
                          {detail.billTypeName || '询价'}单号：
                          <Link
                            to={`/mp/purchase/inquiry/prod/detail/${companyCode}/${item.inqXkNo}`}
                            key={index}
                          >
                            {item.inqXkNo}
                          </Link>
                        </li>
                      </ul>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {/* 单头自定义 */}
          <div className="order-detail-block">
            {/* 单头自定义 */}
            <HeadCustField
              fieldSetting={fieldSetting}
              detail={detail}
              setDetail={setDetail}
              isPurchase={true}
            ></HeadCustField>
          </div>

          <div className="order-detail-block">
            <div className="order-detail-title">
              <label>报价汇总</label>
            </div>
            <ul>
              <li className="order-detail-item">
                <label className="order-detail-label">入选总金额</label>
                <div className="order-detail-value">
                  <span className="yellow">
                    {' '}
                    {formatNumber(
                      detail.totalSelectAmount,
                      decimalPlace.Amount_Decimal_Place
                    )}
                  </span>
                </div>
              </li>
            </ul>
          </div>

          <div className="order-detail-block">
            <div className="order-detail-title">
              <label>报价对比</label>
            </div>
            <PriceCompare
              prodList={detail.pageLineList?.list}
              companyCode={companyCode}
              decimalPlace={decimalPlace}
              isWfLineEdit={isWfLineEdit}
              doubleInquiryFlag={detail.doubleInquiryFlag}
              workflow={workflow}
              setFileList={setFileList}
              handleDrawer={data => handleDrawer(data)}
              onFileListFetched={(businessType, obj) =>
                showFileList(businessType, obj)
              }
              handleInput={(e, item, key) => handleInput(e, item, key)}
            ></PriceCompare>
          </div>
          <div className="order-detail-block">
            <div className="order-detail-title">
              <label>{detail.billTypeName}项目总结</label>
            </div>
            <div className="order-detail-list" style={{ padding: '15px' }}>
              {/* {detail.biddingSummaryShow} */}
              <div
                dangerouslySetInnerHTML={{
                  __html: detail.biddingSummaryShow
                }}
              ></div>
            </div>
          </div>
        </div>
      )}
      {User.checkAuth('10071002') &&
        detail.isMergedByOther === 0 &&
        detail.status !== 6 && (
          <div className="wrap m-flex-box fixed-bottom">
            {detail.status === 7 &&
              User.checkAuth('10050306') &&
              detail.isOaAudit !== 1 &&
              ((workflow.data?.inqu_cfm_5?.complete && detail.billType === 1) ||
                (workflow.data?.bid_cfm_5?.complete &&
                  detail.billType === 2)) && (
                <Button
                  type="default"
                  onClick={() => {
                    handle('publish');
                  }}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  发布比价结果
                </Button>
              )}
            {detail.status === 4 && (
              <Button
                type="default"
                onClick={() => {
                  handle('terminate');
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                终止{detail.billTypeName}
              </Button>
            )}
            {detail.status === 7 &&
              detail.isOaAudit !== 1 &&
              !workflow.isPending && (
                <Button
                  type="default"
                  onClick={() => {
                    handle('reactivate');
                  }}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  重新比价
                </Button>
              )}
            {detail.status === 7 &&
              workflow.lineEditFlag === 1 &&
              !isWfLineEdit && (
                <Button
                  type="default"
                  onClick={() => {
                    setIsWfLineEdit(true);
                  }}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  审核编辑
                </Button>
              )}
            {detail.status === 7 &&
              workflow.lineEditFlag === 1 &&
              isWfLineEdit && (
                <Button
                  type="default"
                  onClick={() => {
                    saveWfLine();
                  }}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  保存
                </Button>
              )}
            {detail.status === 7 &&
              workflow.lineEditFlag === 1 &&
              isWfLineEdit && (
                <Button
                  type="default"
                  onClick={() => {
                    setIsWfLineEdit(false);
                  }}
                  className="m-flex-item u-btn u-btn_line"
                >
                  取消
                </Button>
              )}
            {detail.status === 4 && (
              <Button
                type="default"
                onClick={() => {
                  handle('finish');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                完成比价
              </Button>
            )}
          </div>
        )}
      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

PriceCompareDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceCompareDetail);
